export default function PostRegistration({ onClose }: { onClose: () => void }) {
  return <aside className="registration-success" role="status"><div><strong>注册成功，第一集可免费观看</strong><p>其他集需单独付费解锁。收藏和观看进度保存在当前浏览器。</p></div><button onClick={onClose}>知道了</button></aside>;
}
